import { Component, OnDestroy, OnInit } from "@angular/core";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { finalize } from "rxjs/operators";
import { OrdenTrabajoDTO } from "../../shared/interfaces/orden-trabajo.interface";
import { DialogService } from "../../shared/services/rest/dialog.service";
import { OrdenesDeTrabajoService } from "../../shared/services/rest/ordenes-de-trabajo.service";
import { DialogTicketComponent } from "./components/dialog-ticket/dialog-ticket.component";

import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { Subscription } from "rxjs";
import { DialogOoccComponent } from "./components/dialog-oocc/dialog-oocc.component";
import { NotificacionesService } from "../../shared/services/rest/notificaciones.service";
import { OrdenesCompraService } from "../../shared/services/rest/orden-compra.service";
import { OrdenCompraDTO } from "../../shared/models/orden-compra.model";
import { FiltrosService } from "../../shared/services/util/filtros.service";
import { ClienteDTO } from "../../shared/interfaces/cliente.interface";
import { ClienteService } from "../../shared/services/rest/cliente.service";
import { MenuUsuarioService } from "../../shared/services/util/menu-usuario.service";
import { config } from "app/app.config";
import { EstadoDTO } from "../../shared/interfaces/estado.interface";
import { CodigoDTO } from "../../shared/interfaces/codigo.interface";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-oott",
    templateUrl: "./oott.component.html",
    styleUrls: ["./oott.component.scss"],
})
export class OOTTComponent implements OnInit, OnDestroy {
    total: number = 0;
    ootts: OrdenTrabajoDTO[];
    mostrarFiltros: boolean;
    clientes: ClienteDTO[];
    estados: EstadoDTO[] = [];
    situaciones: CodigoDTO[];
    estadoPago: CodigoDTO[];
    setearFiltros: boolean;
    private subscripciones: Subscription;
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _oottSrvc: OrdenesDeTrabajoService,
        private _dialogSrvc: DialogService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _notificacionSrvc: NotificacionesService,
        private _ooccSrvc: OrdenesCompraService,
        private _filtroSrvc: FiltrosService,
        private _clienteSrvc: ClienteService,
        private _menuUsuarioSrvc: MenuUsuarioService,
        private activatedRoute: ActivatedRoute
    ) {
        this._filtroSrvc.getFiltro("filtrosOOTT");
        this.activatedRoute.queryParams.subscribe((queryParams) => {
            if (Object.entries(queryParams).length > 0) {
                this.setearFiltros = true;
                console.log('queryParams',queryParams);
                this.mostrarFiltros = true;
                //setear los filtros
                if (queryParams.situacion) {
                    this._filtroSrvc.setFiltro(
                        "filtrosOOTT",
                        "situacion",
                        queryParams.situacion,
                        queryParams.nombre
                    );
                }
                if (queryParams.idEstado) {
                    this._filtroSrvc.setFiltro(
                        "filtrosOOTT",
                        "estadoOOTT",
                        queryParams.idEstado,
                        queryParams.nombre
                    );
                }
                if (queryParams.pagoTrabajo) {
                    this._filtroSrvc.setFiltro(
                        "filtrosOOTT",
                        "estadoPago",
                        queryParams.pagoTrabajo,
                        queryParams.nombre
                    );
                }

            } else {
                this.mostrarFiltros = false;
                this.setearFiltros = false;
            }
        });

        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    ngOnInit(): void {
        this.buscarOrdenesDeTrabajo();
        Object.keys(config.oott.estados).forEach((key) => {
            const estado = config.oott.estados[key];
            this.estados.push({
                id: estado.id,
                descripcion: estado.descripcion,
            });
        });

        if (this._menuUsuarioSrvc.esSupervisor()) {
            this._clienteSrvc
                .fetchClientes(0, "desc")
                .subscribe((resp) => (this.clientes = resp.content));
        } else {
            this.clientes = [];
        }

        this.situaciones = [
            { id: 0, nombre: "Todas" },
            { id: 2, nombre: "Sin OOCC" },
            { id: 1, nombre: "Con OOCC" },
        ];

        this.estadoPago = [
            { id: 0, nombre: "Todas" },
            { id: 2, nombre: "Pendiente" },
            { id: 1, nombre: "Pagado" },
        ];
    }

    ngAfterViewInit(): void {
        //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
        //Add 'implements AfterViewInit' to the class.
        //console.log("paso");
    }

    buscarOrdenesDeTrabajo() {
        this._fuseProgressBarService.show();

        this._oottSrvc
            .fetchOOTT()
            .pipe(finalize(() => {this._fuseProgressBarService.hide()}))
            .subscribe((resp) => {
                this.total = resp.totalElements;
                this.ootts = resp.content;
                this._oottSrvc.oottsChanged$.next(resp);
            });
    }

    editarNroTicket(oott: OrdenTrabajoDTO) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogTicketComponent,
            "clase-dialog",
            "600px",
            oott
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log("Dialog result:", result);
            if (result) {
                this._fuseProgressBarService.show();

                this._oottSrvc
                    .asignarTicket(oott.idOrdenTrabajo, result.nroTicket)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        oott.ticket = result.nroTicket;
                        this._notificacionSrvc.mostrarNotificacion(
                            "Ticket asignado",
                            "success"
                        );
                    });
            }
        });
    }

    asignarOOCC(ordenesTrabajo: OrdenTrabajoDTO[]) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogOoccComponent,
            "clase-dialog",
            "600px",
            null
        );
        const idCliente = ordenesTrabajo[0].sucursal.cliente.id;
        const listaOrdenesTrabajo = ordenesTrabajo.map(
            (oott) => oott.idOrdenTrabajo
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                //this.procesando=true;
                //console.log("Dialog result:", result);
                const { nroOOCC, rutFacturar, fecha } = result;
                const fechaStr = fecha.toISOString().split("T")[0];
                const rutStr = rutFacturar.split("-")[0];

                //console.log();
                const oocc = new OrdenCompraDTO(
                    idCliente,
                    fechaStr,
                    rutStr,
                    nroOOCC,
                    listaOrdenesTrabajo
                );

                //console.log(oocc);
                this._fuseProgressBarService.show();
                this._ooccSrvc
                    .asociarOOTTAOOCC(oocc)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        this._oottSrvc.oottsRefresh$.next(true);
                        //console.log(resp);
                        this._notificacionSrvc.mostrarNotificacion(
                            "Orden de compra generada",
                            "success"
                        );
                        this.buscarOrdenesDeTrabajo();
                    });
            }
            
        });
    }

    filtrar(event) {
        this._oottSrvc.resetPaginador();
        this._oottSrvc.oottsRefresh$.next(true);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
